import Vue from 'vue';
import _ from 'lodash';

import { MONTHS_OF_YEAR } from '@/classes/common/Constants';
import { PlbscfYearItem } from '@/classes/service/AbstractPlbscfService';
import AbstractデータService from '@/classes/service/AbstractデータService';

export default Vue.extend({
  name: 'M計画三表TableMixin',

  methods: {
    divideYearlyValue(yearItem: PlbscfYearItem, yearlyValue: number, isYConfig = false, isCF計算書 = false): void {
      if (!isYConfig) {
        // 計画0, 1期以外はmonthlyValuesは不要
        if (yearItem.item.monthlyValues === undefined) {
          this.$set(yearItem.item, 'value', yearlyValue);
          return;
        }

        // optionValueが存在する（貸借 かつ 計画0/1期）場合
        if (yearItem.optionValue !== undefined) {
          this.$set(yearItem, 'optionValue', yearlyValue);
          // 最終月、合計値も設定する
          this.sumMonthlyValues(yearItem, MONTHS_OF_YEAR - 1, yearlyValue);
          return;
        }
        AbstractデータService.divideYearlyValue(yearItem.item, yearlyValue);
      } else if (isYConfig && isCF計算書) {
        if (yearItem.item.monthlyValues === undefined) {
          this.$set(yearItem.item, 'yValue', yearlyValue);
        }
      } else {
        this.$set(yearItem.item, 'yValue', yearlyValue);
        // set value = yValue when 計画 > 1 (old data)
        if (yearItem.item.monthlyValues === undefined) {
          this.$set(yearItem.item, 'value', yearlyValue);
        }
        // when data is still empty in db
        if (yearItem.item.value == 0 && yearItem.optionValue == undefined) {
          this.$set(yearItem, 'optionValue', undefined);
        }
      }
    },
    sumMonthlyValues(yearItem: PlbscfYearItem, monthIndex: number, monthlyValue: number): void {
      // 計画0, 1期以外はこの関数を呼ばない想定

      // optionValueが存在し（貸借 かつ 計画0/1期）、最終月を更新する場合
      if (yearItem.optionValue !== undefined && monthIndex === MONTHS_OF_YEAR - 1) {
        this.$set(yearItem, 'optionValue', monthlyValue);
      }
      this.$set(yearItem.item.monthlyValues!, monthIndex, monthlyValue);
      yearItem.item.value = _.sum(yearItem.item.monthlyValues);
    },
  },
});
